export default __webpack_public_path__ + "static/celestia-logo-6b13e09a328e6cf748bdcbc98e6b4b88.svg";